



























import Vue from 'vue';

export default Vue.extend({
    props: {
        'append-icon': {
            required: false,
            type: String,
        },
        'prepend-inner-icon': {
            required: false,
            type: String,
        },
        width: {
            required: false,
            type: String,
        },
    },
    data() {
        return {
            iconColor: 'grey lighten-1',
        };
    },
    methods: {},
});
